import React, { useState, useEffect } from 'react';
import Navbar from '../layout/Navbar';
import image2 from '../assets/img2.jpg';
import image3 from '../assets/img3.jpg';
import image4 from '../assets/img4.jpg';
import image5 from '../assets/img5.jpg';
import image7 from '../assets/img7.jpg';
import About from './About';
import Product from './Product';
import Material from './Material';
import Contact from './Contact';
import { ArrowUp, Phone } from 'lucide-react';
import Footer from '../layout/Footer';
import { FaWhatsapp } from 'react-icons/fa';

const Home = () => {
    const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
    const [showScrollTop, setShowScrollTop] = useState(false);
    const slides = [image2, image3, image4, image5, image7];

    // Slider logic
    const changeSlide = (direction) => {
        let newIndex = currentSlideIndex + direction;
        if (newIndex >= slides.length) newIndex = 0;
        if (newIndex < 0) newIndex = slides.length - 1;
        setCurrentSlideIndex(newIndex);
    };

    const currentSlide = (index) => {
        setCurrentSlideIndex(index);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            changeSlide(1);
        }, 5000);
        return () => clearInterval(interval);
    }, [currentSlideIndex]);

    // Scroll-to-top logic
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setShowScrollTop(true);
            } else {
                setShowScrollTop(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="animate-fadeIn">
            <Navbar />
            <section
                id="home"
                className="relative w-full min-h-screen max-h-[100vh] overflow-hidden"
            >
                {/* Background Slider */}
                <div className="absolute top-0 left-0 w-full h-full z-0">
                    {slides.map((src, index) => (
                        <div
                            key={index}
                            className={`absolute inset-0 w-full h-full transition-opacity duration-1000 ${index === currentSlideIndex ? 'opacity-100' : 'opacity-0'
                                }`}
                            style={{
                                backgroundImage: `url(${src})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}
                        ></div>
                    ))}
                </div>

                {/* Prev Button */}
                <button
                    className="absolute top-1/2 left-4 -translate-y-1/2 bg-black/30 text-white w-10 h-10 rounded-full text-lg cursor-pointer hover:bg-black/50 transition z-20 md:w-12 md:h-12 md:text-xl"
                    onClick={() => changeSlide(-1)}
                >
                    ❮
                </button>

                {/* Next Button */}
                <button
                    className="absolute top-1/2 right-4 -translate-y-1/2 bg-black/30 text-white w-10 h-10 rounded-full text-lg cursor-pointer hover:bg-black/50 transition z-20 md:w-12 md:h-12 md:text-xl"
                    onClick={() => changeSlide(1)}
                >
                    ❯
                </button>

                {/* Dots */}
                <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex gap-2 z-20">
                    {slides.map((_, index) => (
                        <span
                            key={index}
                            className={`w-2.5 h-2.5 rounded-full ${index === currentSlideIndex ? 'bg-white' : 'bg-white/50'
                                } cursor-pointer transition-colors`}
                            onClick={() => currentSlide(index)}
                        ></span>
                    ))}
                </div>
            </section>

            <About showFooter={false} />
            <Product showFooter={false} />
            <Material showFooter={false} />
            <Contact showFooter={false} />
            <Footer />

            <div className="fixed bottom-5 right-5 flex flex-col gap-3 z-20">
                <a
                    href="tel:+919426788499"
                    className="bg-sky-500 text-white w-12 h-12 rounded-lg text-xl flex items-center justify-center cursor-pointer hover:bg-sky-700 transition-all"
                    title="Call Us"
                >
                    <Phone />
                </a>
                <a
                    href="https://wa.me/+919426788499"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-[#3ed145] text-white w-12 h-12 rounded-lg text-xl flex items-center justify-center cursor-pointer hover:bg-[#2f8734] transition-all"
                    title="Message on WhatsApp"
                >
                    <FaWhatsapp className="h-12 w-8" />
                </a>
                {showScrollTop && (
                    <button
                        className="bg-[#e0990b] text-white w-12 h-12 rounded-lg text-xl flex items-center justify-center cursor-pointer hover:bg-[#95712a] transition-all"
                        onClick={scrollToTop}
                        title="Scroll to Top"
                    >
                        <ArrowUp />
                    </button>
                )}
            </div>
        </div>
    );
};

export default Home;
